<div class="min-h-screen flex justify-center items-center py-10">
    <div class="w-full max-w-lg bg-gray-900 p-8 rounded-lg shadow-lg">
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-8 text-center">Enter Your Details</h2>
      
      <!-- User Details Form -->
      <form id="userDetailsForm">
        <!-- Full Name -->
        <div class="mb-6">
          <label for="fullName" class="block text-gray-300 mb-2">Full Name</label>
          <input type="text" id="fullName" name="fullName" class="block w-full bg-gray-900 border border-gray-600 rounded py-3 px-4 text-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500" placeholder="Your Full Name" required>
        </div>
  
        <!-- Email -->
        <div class="mb-6">
          <label for="email" class="block text-gray-300 mb-2">Email Address</label>
          <input type="email" id="email" name="email" class="block w-full bg-gray-900 border border-gray-600 rounded py-3 px-4 text-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500" placeholder="Your Email Address" required>
        </div>
  
        <!-- Phone Number -->
        <div class="mb-6">
          <label for="phoneNumber" class="block text-gray-300 mb-2">Phone Number</label>
          <input type="tel" id="phoneNumber" name="phoneNumber" class="block w-full bg-gray-900 border border-gray-600 rounded py-3 px-4 text-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500" placeholder="Your Phone Number" required>
        </div>
  
        <!-- Continue Button -->
        <div class="mt-8">
          <button type="submit" class="w-full bg-black text-white font-bold py-3 px-6 rounded">
            Continue to Checkout
          </button>
        </div>
      </form>
    </div>
  </div>
  